<template>
    <ul class="navs">
        <li class="home">
            <RouterLink to="/">首页</RouterLink>
        </li>
        <li v-for="item in navList" :key="item.id" @click="jump(item.id)">
            <span href="#">{{item.name}}</span>
        </li>
    </ul>
</template>
<script>
export default {
  name: 'HeaderNav',
  setup () {
    const navList = [
      { name: 'Soul媒体介绍', id: 'serve' },
      { name: 'Soul投放案例', id: 'case' },
      { name: '开户常见问题', id: 'question' },
      { name: '联系我们', id: 'footer' }
    ]
    const jump = (data) => {
      document.querySelector(`#${data}`).scrollIntoView({
        behavior: 'smooth', // 平滑过渡
        block: 'start' // 上边框与视窗顶部平齐。默认值
      })
    }

    return { navList, jump }
  }
}
</script>

<style lang="less" scoped>
.navs {
  width: 755px;
  display: flex;
  justify-content: space-between;
  padding-left: 40px;
  position: relative;
  z-index: 998;
  .home {
    background: url(~@/assets/images/-2483.png) no-repeat;
    font-size: 16px;
    line-height: 33px;
    height: 33px;
  }
  > li {
    text-align: center;
    width: 120px;
    height: 33px;
    cursor: pointer;
    > span {
      font-size: 16px;
      line-height: 32px;
      height: 32px;
      display: inline-block;
    }
    &:hover {
      background: url(~@/assets/images/-2483.png);
      opacity: 1;
    }
  }
}
</style>
